/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportDeleteUploadMutationResponse, SocialExportDeleteUploadPathParams, SocialExportDeleteUpload400, SocialExportDeleteUpload401, SocialExportDeleteUpload403, SocialExportDeleteUpload404 } from "../models/SocialExportDeleteUpload";

export function getSocialExportDeleteUploadUrl(id: SocialExportDeleteUploadPathParams["id"]) {
  const res = { method: 'DELETE', url: `/social-export/v1/upload/${id}` as const }
  return res
}

/**
 * @description Removes the published media from the platform (when applicable) and deletes the upload record.
 * @summary Delete an upload from the platform
 * {@link /social-export/v1/upload/:id}
 */
export async function socialExportDeleteUpload(id: SocialExportDeleteUploadPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportDeleteUploadMutationResponse, ResponseErrorConfig<SocialExportDeleteUpload400 | SocialExportDeleteUpload401 | SocialExportDeleteUpload403 | SocialExportDeleteUpload404>, unknown>({ method : "DELETE", url : getSocialExportDeleteUploadUrl(id).url.toString(), ... requestConfig })
  return res.data
}